import { FC, useMemo } from "react";

import orderOptimizerRailyDetailsHiddenDetailsCenterTablesTableHelper from "./order-optimizer-raily-details-hidden-details-center-tables.helper";
import OrderOptimizerRailyDetailsHiddenDetailsCenterTablesTableRow from "./types/order-optimizer-raily-details-hidden-details-center-tables-table-row";
import OrderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableComponent from "./driver/order-optimizer-raily-details-hidden-details-heading-tables-driver-table.component";
import OrderOptimizerRailyDetailsHiddenDetailsTablesOrdersComponent from "./orders/order-optimizer-raily-details-hidden-details-center-tables-orders.component";
import TableComponent, {
  TableProps,
} from "../../../../../../common/components/table/table.component";
import uuidService from "../../../../../../common/utils/uuid/uuid.service";
import { useAppContext } from "../../../../../../context/app.context";
import {
  OrderOptimizerRailyDetailsItemDriver,
  OrderOptimizerRailyDetailsItemOrders,
  OrderOptimizerRailyDetailsItemStepsOrders,
} from "../../common/types/order-optimizer-raily-details-item";

type OrderOptimizerRailyDetailsHiddenDetailsCenterTablesTableProps = Pick<
  TableProps,
  "isError" | "isLoading"
> & {
  driver: OrderOptimizerRailyDetailsItemDriver | null;
  orders: OrderOptimizerRailyDetailsItemOrders[];
  ordersSteps: OrderOptimizerRailyDetailsItemStepsOrders[];
};

const OrderOptimizerRailyDetailsHiddenDetailsCenterTablesTableComponent: FC<
  OrderOptimizerRailyDetailsHiddenDetailsCenterTablesTableProps
> = (props) => {
  const { selectedAppLanguage } = useAppContext();

  const columns = useMemo(() => {
    return orderOptimizerRailyDetailsHiddenDetailsCenterTablesTableHelper.getColumns();
  }, [selectedAppLanguage]);

  const allStepPoints = useMemo(() => {
    return props.ordersSteps.map((step) => step.points).flat();
  }, [props.ordersSteps]);

  const stepOffsets: number[] = useMemo(() => {
    const offsets: number[] = [];
    let totalOffset = 0;

    props.ordersSteps.forEach((steps) => {
      offsets.push(totalOffset);
      totalOffset += steps.points.length;
    });

    return offsets;
  }, [props.ordersSteps]);

  const createTableRow = (
    order: OrderOptimizerRailyDetailsItemOrders,
    steps: OrderOptimizerRailyDetailsItemStepsOrders,
    stepOffset: number,
    orderIndex: number
  ): OrderOptimizerRailyDetailsHiddenDetailsCenterTablesTableRow => {
    return {
      id: uuidService.generate(),
      value: {
        orders: (
          <div className="order_optimizer_raily_details_hidden_details_center_tables_order">
            <OrderOptimizerRailyDetailsHiddenDetailsTablesOrdersComponent
              allStepPoints={allStepPoints}
              order={order}
              step={steps}
              stepOffset={stepOffset}
              orderIndex={orderIndex}
              driver={props.driver}
            />
          </div>
        ),
        driver: (
          <div className="order_optimizer_raily_details_hidden_details_center_tables_driver">
            <OrderOptimizerRailyDetailsHiddenDetailsCenterTablesDriverTableComponent
              detailsStepsOrdersPointsItems={steps.points}
            />
          </div>
        ),
      },
    };
  };

  const rows: OrderOptimizerRailyDetailsHiddenDetailsCenterTablesTableRow[] =
    useMemo(() => {
      return props.orders.map((order, orderIndex) =>
        createTableRow(
          order,
          props.ordersSteps[orderIndex],
          stepOffsets[orderIndex],
          orderIndex
        )
      );
    }, [props.orders, props.ordersSteps, stepOffsets, selectedAppLanguage]);

  return (
    <TableComponent
      columns={columns}
      rows={rows}
      isLoading={props.isLoading}
      isError={props.isError}
      noHeader
    />
  );
};

export default OrderOptimizerRailyDetailsHiddenDetailsCenterTablesTableComponent;
